export default __webpack_public_path__ + "b72c32acf6747fd2b6f5da8337f1dbfe.png";